const KEY = "lead_attribution";
const REF_KEY = "partner_ref";
const TTL = 90 * 24 * 3600 * 1000;

// Partner credit: the latest ?ref=CODE click is kept for 90 days.
const captureRef = () => {
  const code = new URLSearchParams(window.location.search).get("ref");
  if (code && /^[a-z0-9]{4,20}$/i.test(code)) localStorage.setItem(REF_KEY, JSON.stringify({ code: code.toLowerCase(), at: Date.now() }));
};

export const getPartnerRef = () => {
  try {
    const r = JSON.parse(localStorage.getItem(REF_KEY) || "null");
    return r && Date.now() - r.at < TTL ? r.code : "";
  } catch { return ""; }
};

// First-touch attribution: where the visitor first came from, kept for 90 days.
export const captureAttribution = () => {
  try {
    captureRef();
    const old = JSON.parse(localStorage.getItem(KEY) || "null");
    if (old && Date.now() - old.at < TTL) return;
    const q = new URLSearchParams(window.location.search);
    const ref = document.referrer && !document.referrer.startsWith(window.location.origin) ? document.referrer : "";
    localStorage.setItem(KEY, JSON.stringify({
      at: Date.now(), referrer: ref.slice(0, 500), landing: (window.location.pathname + window.location.search).slice(0, 300),
      utm_source: (q.get("utm_source") || "").slice(0, 100), utm_medium: (q.get("utm_medium") || "").slice(0, 100), utm_campaign: (q.get("utm_campaign") || "").slice(0, 150),
    }));
  } catch { /* storage unavailable */ }
};

export const getAttribution = () => {
  try {
    const a = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!a) return null;
    const { at, ...rest } = a;
    return { ...rest, site_host: window.location.host };
  } catch { return null; }
};
